import React from 'react';

const MapMarker = () => {
    return <img src='img/mapmarker.png' alt="Map Marker" style={{height:"50px", width: "50px"}} />;
}

export default MapMarker;
